<template>
    <div class="TopFooterContent">
        <div class="TopFooterContent-top">
            <div class="name">今日</div>
            <div class="name">本月</div>
            <div class="name active">本年</div>
        </div>
        <div class="TopFooterContent-bottom">
            <PublicEcharts :key="keyEcharts" :id="'TopFooterContent-bottom'" :chartsData="growthData" :type="'darkLine'"
                :options="options" />
        </div>
    </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts";
export default {
    name: "TopFooterContent",
    props: {},
    components: { PublicEcharts },
    data() {
        return {
            growthData: {
                "unit": "万kw·h", "xData": ["01", "02", "03", "04", "05"],
                "dataArr": [{ "name": "2023", "data": ["11.05", "12.34", "13.82", "12.14", "14.92"] },
                { "name": "2022", "data": ["13.12", "11.29", "10.50", "12.10", "12.65"] }]
            },
            options: {
                legend: {
                    show: true,
                    textStyle: {
                        color: "#fff",
                    },
                    // left: "2%",
                    top: "2%",
                },
                grid: {
                    top: "30px",
                    left: "60px",
                    right: "25px",
                    bottom: "30px",
                },
                // animation: false,
                yAxis: [
                    {
                        type: "value",
                        name: "单位:万kw·h",
                        nameTextStyle: {
                            color: "#82AFC6",
                            fontSize: 10,
                            padding: [0, 0, 0, -30],
                        },
                        axisTick: {
                            show: false,
                        },
                        axisLine: {
                            show: false,
                        },

                        axisLabel: {
                            color: "rgb(116,166,181)",
                        },
                        splitLine: {
                            lineStyle: {
                                type: "dashed",
                                color: "#0F2766",
                            },
                        },
                        max: function (value) {
                            if (value.max < 0) {
                                return Math.ceil(value.max + 2);
                            }
                        },
                        min: function (value) {
                            if (value.min > 0) {
                                return Math.floor(value.min - 1);
                            }
                        },
                    },
                ],
            },
            keyEcharts: 1,
        }
    },
    computed: {},
    methods: {
        contentResize() {
            this.keyEcharts++
        },
    },
    created() {
    },
    mounted() {
        this.$nextTick(function () {
            this.contentResize()
        })
        this.$bus.$on("getChangeMenuType", (data) => {
            this.$nextTick(function () {
                this.contentResize()
            })
        });
    },
    beforeDestroy() {
        this.$bus.$off("getChangeMenuType");
    }
}
</script> 

<style lang="scss" scoped>
.TopFooterContent {
    width: 100%;
    height: 100%;

    &-top {
        height: 20px;
        @include setFlexEnd;

        .name {
            text-align: center;
            width: 50px;
            height: 20px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #AEB2C2;
            line-height: 14px;
        }

        .active {
            height: 19px;
            color: #16E9F4;
            border-bottom: 1px solid;
            border-image: linear-gradient(270deg, rgba(49, 246, 250, 0), rgba(49, 246, 250, 0.68), rgba(22, 233, 244, 0)) 1 1;
        }
    }

    &-bottom {
        height: calc( 100% - 30px );
        // height: 126px;
        width: 100%;
    }
}
</style>